import React from "react";

// Spotlight ring over the anchored element + a small pointer label that names
// the feature the chat panel is describing. Purely visual (no controls).
const PAD = 6;

const CoachBubble = ({ rect, title, side = "bottom", insideModal = false }) => {
  if (!rect) return null;
  const z = insideModal ? 1460 : 1310;

  // <html> has `zoom: 0.8` at desktop widths (app.global.scss). getBoundingClientRect()
  // returns post-zoom (visual) coordinates, but CSS top/left on this fixed element get
  // scaled by that same zoom AGAIN — which would place the ring at 0.8x the element's
  // position (up-and-left). Divide the rect by the live zoom so it lands on target.
  // Firefox doesn't apply `zoom` -> factor resolves to 1 (no-op).
  const zoom =
    (typeof window !== "undefined" &&
      parseFloat(getComputedStyle(document.documentElement).zoom)) || 1;
  const r = {
    top: rect.top / zoom,
    left: rect.left / zoom,
    width: rect.width / zoom,
    height: rect.height / zoom,
  };

  // The spotlight: a box over the element with a huge box-shadow that dims
  // everything else and draws a ring around the target.
  const ringStyle = {
    position: "fixed",
    top: r.top - PAD,
    left: r.left - PAD,
    width: r.width + PAD * 2,
    height: r.height + PAD * 2,
    borderRadius: 8,
    boxShadow: `0 0 0 3px #6B43B5, 0 0 0 9999px rgba(15, 8, 30, ${insideModal ? 0.35 : 0.5})`,
    zIndex: z,
    pointerEvents: "none",
    transition: "all 140ms ease",
  };

  // Pointer label position relative to the ring.
  const labelGap = 12;
  let labelStyle = { position: "fixed", zIndex: z + 1, maxWidth: 240 };
  if (side === "top") labelStyle = { ...labelStyle, top: r.top - PAD - labelGap, left: r.left + r.width / 2, transform: "translate(-50%, -100%)" };
  else if (side === "left") labelStyle = { ...labelStyle, top: r.top + r.height / 2, left: r.left - PAD - labelGap, transform: "translate(-100%, -50%)" };
  else if (side === "right") labelStyle = { ...labelStyle, top: r.top + r.height / 2, left: r.left + r.width + PAD + labelGap, transform: "translate(0, -50%)" };
  else labelStyle = { ...labelStyle, top: r.top + r.height + PAD + labelGap, left: r.left + r.width / 2, transform: "translate(-50%, 0)" };

  return (
    <>
      <div className="go-spotlight" style={ringStyle} aria-hidden="true" />
      <div className="go-pointer-label" style={labelStyle} aria-hidden="true">
        <span className="go-pointer-dot" /> {title}
      </div>
    </>
  );
};

export default CoachBubble;
